export default __webpack_public_path__ + "static/media/img_500.c1a2ca35.svg";